import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from 'Views/dashboard/Dashboard.vue';
import AboutUs from 'Views/about_us/AboutUs.vue';
import Contact from 'Views/contact/Contact.vue';
import Home from 'Views/home/Home.vue';
import Job from 'Views/job/Job.vue';
import JobList from 'Views/job/list/JobList.vue';
import JobListSearch from 'Views/job/search/JobList.vue';
import JobDetail from 'Views/job/show/JobDetail.vue';
import Service from 'Views/service/Service.vue';
import ListItemService from 'Views/service/item_service/ListItemService.vue';
import ListContentService from 'Views/service/content/list/ListContentService.vue';
import ShowContentService from 'Views/service/content/show/ShowContentService.vue';
import ListScheduleService from 'Views/service/schedule/ListScheduleService.vue';
import ServiceContent from 'Views/service/content/ServiceContent.vue';
import News from 'Views/news/News.vue';
import ListNews from 'Views/news/list/ListNews.vue';
import DetailNews from 'Views/news/detail/DetailNews.vue';
import ListQuestionService from 'Views/question/ListQuesntion.vue';
import School from 'Views/school/School.vue';
import ListSchool from 'Views/school/list/ListSchool.vue';
import ShowSchool from 'Views/school/show/ShowSchool.vue';
import ListItemSchool from 'Views/school/list_item/ListItemSchool.vue';
import Top from 'Views/top/Top.vue';
import ListTop from 'Views/top/list/ListTop.vue';
import DetailTop from 'Views/top/detail/DetailTop.vue';
import LittTopItem from 'Views/top/list_item/ListItemTop.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
        },
        {
          path: '/about-us',
          name: 'about-us',
          component: AboutUs,
        },
        {
          path: '/contact',
          name: 'contact',
          component: Contact,
        },
        {
          path: '/top',
          component: Top,
          children: [
            {
              path: '',
              name: 'top.list',
              component: ListTop,
            },
            {
              path: '/top/item/:address',
              name: 'top.item',
              component: LittTopItem,
            },
            {
              path: '/top/:id',
              name: 'top.show',
              component: DetailTop,
            },
          ],
        },
        {
          path: '/news',
          component: News,
          children: [
            {
              path: '',
              name: 'news.list',
              component: ListNews,
            },
            {
              path: '/news/:id',
              name: 'news.show',
              component: DetailNews,
            },
          ],
        },
        {
          path: '/job',
          component: Job,
          children: [
            {
              path: '',
              name: 'job.list',
              component: JobList,
            },
            {
              path: '/job/search',
              name: 'job.search',
              component: JobListSearch,
            },
            {
              path: ':id',
              name: 'job.show',
              component: JobDetail,
            },
          ],
        },
        {
          path: '/question',
          name: 'question.list',
          component: ListQuestionService,
        },
        {
          path: '/schools',
          component: School,
          children: [
            {
              path: '',
              name: 'schools.list',
              component: ListSchool,
            },
            {
              path: '/schools/item/:type_contact',
              name: 'schools.item',
              component: ListItemSchool,
            },
            {
              path: '/schools/:id',
              name: 'schools.show',
              component: ShowSchool,
            },
          ],
        },
        {
          path: '/services',
          component: Service,
          children: [
            {
              path: '',
              name: 'itemService',
              component: ListItemService,
            },
            {
              path: '/services/content',
              component: ServiceContent,
              children: [
                {
                  path: '',
                  name: 'contentService',
                  component: ListContentService,
                },
                {
                  path: '/services/content/:id',
                  name: 'service.show',
                  component: ShowContentService,
                },
              ],
            },
            {
              path: '/services/schedule',
              name: 'scheduleService',
              component: ListScheduleService,
            },
          ],
        },
      ],
    },
    {
      path: '*',
      name: 'dashboard',
      component: Dashboard,
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
        },
      ],
    },
  ],
});

export default router;
